import React from "react";
import classnames from "classnames";

import RequestEarlyAccessForm, {
  RequestEarlyAccessFormProps,
} from "./RequestEarlyAccessForm";
import { useUser } from "src/hooks/useUser";
import { WordPressPost } from "src/lib/wp";

type SignupCalloutProps = RequestEarlyAccessFormProps & {
  Icon?: JSX.Element;
  post?: WordPressPost;
  purple?: boolean;
  subtitle?: string | JSX.Element;
  title?: string | JSX.Element;
};

const SignupCallout: React.FC<SignupCalloutProps> = ({
  Icon,
  post,
  purple,
  subtitle,
  title,
  ...formProps
}) => {
  const [user] = useUser();
  if (user) {
    if (Icon) {
      // make up for lost padding on /platform pages
      return <div style={{ height: 50 }} />;
    }
    return null;
  }

  const classes = classnames("page-footer-cta", { purple });

  const customTitle = post?.acf?.signup_callout_title;

  return (
    <div className={classes}>
      {Icon && <div className="signup-background-icon">{Icon}</div>}

      <div className="container">
        <div className="signup-callout-box">
          <div className="top-stripe" />
          <h3 className="signup-title">
            {customTitle || title || "Build your own simulations"}
          </h3>
          <p className="signup-subtitle">
            {subtitle ??
              "HASH is the no-cost platform for openly modeling the world"}
          </p>
          <RequestEarlyAccessForm {...formProps} />
        </div>

        <p className="white signup-terms">
          <span>By signing up you agree to our </span>
          <a href="/legal/terms" target="_blank">
            terms and conditions
          </a>
          <span> and </span>
          <a href="/legal/privacy" target="_blank">
            privacy policy
          </a>
        </p>
      </div>
    </div>
  );
};

export default SignupCallout;
